/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponseModel, BaseQuery } from "src/types"
import axiosInstance from "./axios"
import { StoreModel } from "src/types/store"

const storeApis = {
  gets: (params: BaseQuery) =>
    axiosInstance.get<any, ApiResponseModel<Array<StoreModel>>>("/getStore", {
      params,
    }),
}

export default storeApis
